module.exports = __webpack_public_path__ + "media/images/xpass/brand_previews/rumble-d81216b442a1ca7d0fb2d18662601097.jpg";